import { Box, Grid } from '@mui/material'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
// import dynamic from 'next/dynamic'
import Card from '../notAlone/card/Card'
import prevBtn from 'src/assets/images/aboutUs/prevBtn.svg'
import nextBtn from 'src/assets/images/aboutUs/nextBtn.svg'
import Slider from 'react-slick'

// const Slider = dynamic(() => import('react-slick').then((m) => m.default), {
//   ssr: false,
// })

type SlideProps = {
  zenMode: boolean
  content: {
    img: string
    name: string
    age: number
    description: string
    secondaryText: string
  }
}

const Slide = ({ zenMode, content }: SlideProps) => {
  return (
    <Grid
      sx={{
        width: '100%',
      }}
      alignContent="center"
      justifyContent="center"
    >
      <Grid
        sx={{
          marginLeft: '14px',
          marginRight: '14px',
        }}
      >
        <Card zenMode={zenMode} content={content} />
      </Grid>
    </Grid>
  )
}

interface IProps {
  zenMode: boolean
  content: {
    img: string
    name: string
    age: number
    description: string
    secondaryText: string
  }[]
}
const PartialSlider: React.FC<IProps> = ({ zenMode, content }) => {
  const slickSettings = {
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: false,
    slidesToShow: 1,
    centerMode: true,
  }
  return (
    <div className="App">
      <Box m="20">
        <Box
          sx={{
            position: 'relative',

            '& .slick-arrow': {
              backgroundColor: 'white',
              position: 'absolute',
              color: 'black',
              width: '38px',
              height: '38px',
              zIndex: 100,
              borderRadius: '50%',
              border: zenMode ? '1px solid black' : 'none',
              transition: '0.2s',
              '&::before': {
                transition: '0.2s',
              },
            },
            '& .slick-prev': {
              left: '40px',
              background: `url(${prevBtn?.src})`,
              '&::before': {
                content: '""',
                width: '38px',
                height: '38px',
              },
              '&:hover': {
                background: `url(${prevBtn?.src})`,
              },
            },
            '& .slick-next': {
              background: `url(${nextBtn?.src})`,
              right: '40px',
              '&::before': {
                content: '""',
                width: '38px',
                height: '38px',
              },
              '&:hover': {
                background: `url(${nextBtn?.src})`,
              },
            },
          }}
        >
          <Slider {...slickSettings}>
            {content && content.length
              ? content.map((curr, index) => (
                  <Slide key={index} zenMode={zenMode} content={curr} />
                ))
              : ''}
          </Slider>
        </Box>
      </Box>
    </div>
  )
}

export default PartialSlider
